import { faCheck, faDiagramProject } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function CardProjectList({ id_parent, idSelected, list, listAccess, change }) {

    /*
    idSelected - выбранный проект
    listAccess - список доступных для выбора проектов
    */


    return (
        <>
            {
                list.filter(a => a.ID_Parent === id_parent).sort((a, b) => a.Name.localeCompare(b.Name)).map((model, index) => (
                    <div key={model.ID} style={{ marginLeft: (5 * model.Level) + '%', marginTop: (model.ID_Parent === null && ('15px')) }}>
                        <div className={listAccess.filter(a => a.ID === model.ID).length > 0 ? "project_item" : "project_item disabled"}
                            onClick={() => listAccess.filter(a => a.ID === model.ID).length > 0 && change(model.ID, model.Name)}>
                            {model.ID_Parent === null && (<FontAwesomeIcon icon={faDiagramProject} className="mr-5 ml-2" />)}
                            {model.Name}
                            {model.ID === idSelected && <div className="check"><FontAwesomeIcon icon={faCheck} className="mr-5 ml-2" /></div>}
                        </div>
                        <CardProjectList id_parent={model.ID} list={list} idSelected={idSelected} listAccess={listAccess} change={change} />
                    </div>
                ))
            }
        </>
    )
}

export default CardProjectList;